import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

const TOKEN_KEY = 'amxp_token';

// Sin concepto de "setup" (eso es del lado docente/admin) — si ya hay sesión,
// siempre va al dashboard del padre.
export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) return true;
  return router.createUrlTree(['/padre/dashboard']);
};
